import React from 'react';
import { Button, Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ELayout from './ELayout';
import { ArrowLeftCircle } from "react-bootstrap-icons";
const LeaveDashboard = () => {
  const navigate = useNavigate();

  return (
    <ELayout heading={
          <div className="mb-3 d-flex align-items-center">
          <Button className="btn btn-secondary" onClick={() => navigate(-1)}>
            <ArrowLeftCircle />
          </Button>
          <span className="ms-3">Leave Management</span>
          </div>
        }
    >
      <Container className="my-4">
        <Row className="justify-content-center g-4">
          <Col xs={12} md={6}>
            <Card className="shadow text-center">
              <Card.Body>
                <Card.Title>Apply for Leave</Card.Title>
                <Card.Text>Submit your leave request for manager approval.</Card.Text>
                <Button variant="primary" onClick={() => navigate('/leave-request')}>
                  Apply Leave
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={6}>
            <Card className="shadow text-center">
              <Card.Body>
                <Card.Title>View Leave History</Card.Title>
                <Card.Text>Check your past leave records and statuses.</Card.Text>
                <Button variant="secondary" onClick={() => navigate('/leave-history')}>
                  View History
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </ELayout>
  );
};

export default LeaveDashboard;
